import React, { useState,useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import debut from '../../../../images/actions/debut.svg';
import mitemps from '../../../../images/actions/mitemps.svg';
import reprise from '../../../../images/actions/reprise.svg';
import fin from '../../../../images/actions/fin.svg';
import prolong from '../../../../images/actions/prolong.svg';
import tab from '../../../../images/actions/tab.svg';
import but from '../../../../images/actions/but.svg';
import remplacement from '../../../../images/actions/remplacement.svg';
import cartons from '../../../../images/actions/cartons.svg';
import tir from '../../../../images/actions/tir.svg';
import penalty from '../../../../images/actions/penalty.svg';
import cpa from '../../../../images/actions/cpa.svg';
import axios from 'axios';
import { API_HOST } from '../../../../config.env';
import _ from 'lodash';
import queryString from 'query-string';
import { Grid } from 'antd-mobile';
import { Page, Fab, Icon } from 'react-onsenui';
import './DeclareActionPage.css';
import { isLiveInProgress } from '../../../../helpers';
import { connect } from 'react-redux';

const DeclareActionPage = props => {
    try {
        setTimeout(function(){ 
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 10);
    }
    catch(e){}
    

    const access = props.connexionReducer;
    const [actionType, setActionType] = useState([]);

    useEffect(() => {
        if(access) {
            const headers = {
                Accept: 'application/ld+json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${access}`
            };
            axios.get(`${API_HOST}/api/action_types?pagination=false`, { headers }).then(response => {
                if(response.status === 200) {
                    setActionType(response.data['hydra:member']);
                }
            })
        }
    }, [access]);

    const { id } = props.match.params;
    let match = {}
    let live = [];
    try {
        match = JSON.parse(queryString.parse(props.history.location.search).match);
        live = JSON.parse(queryString.parse(props.history.location.search).live);
    }
    catch(e) {}

    const highlights = [
        {icon: debut, text: 'Début', props: {
            history: props.history,
            to: `/live/${id}/debut`,
            action: _.pick(_.find(actionType, {name: 'Début'}), '@id'), 
            settings: {debutAt: match.date}
        }},
        {icon: mitemps, text: 'Mi-temps', props: {
            action: _.pick(_.find(actionType, {name: 'Mi-temps'}), '@id')
        }},
        {icon: reprise, text: 'Reprise', props: {
            action: _.pick(_.find(actionType, {name: 'Reprise'}), '@id')
        }},
        {icon: fin, text: 'Fin', props: {
            action: _.filter(actionType, (a) => _.includes(['Fin de match', 'Fin des prolongations'], a.name))
        }}
    ]

    const overtime = [
        {icon: prolong, text: 'Prolong.', props: {
            action: _.pick(_.find(actionType, {name: 'Prolongations'}), '@id')
        }},
        {icon: tab, text: 'Tirs au but', props: {
            action: _.pick(_.find(actionType, {name: 'Séance de tirs aux buts'}), '@id')
        }}
    ];

    const actions = [
        {icon: but, text: 'But !', props: {
            history: props.history,
            to: `/live/${id}/but`,
            action: JSON.stringify(_.pick(_.find(actionType, {name: 'But'}), ['data', '@id'])),
            live: live
        }},
        {icon: remplacement, text: 'Remplacement'},
        {icon: cartons, text: 'Cartons', props: {
            history: props.history,
            to: `/live/${id}/cartons`,
            action: JSON.stringify(_.pick(_.find(actionType, {name: 'Cartons'}), ['data', '@id'])),
            live: live
        }},
        {icon: tir, text: 'Tirs', props: {
            history: props.history,
            to: `/live/${id}/tir`,
            action: JSON.stringify(_.pick(_.find(actionType, {name: 'Tir'}), ['data', '@id'])),
            settings: {
                tir: 'tir'
            },
            live: live
        }},
        {icon: penalty, text: 'Penalty', props: {
            history: props.history,
            to: `/live/${id}/penalty_declaration`,
            action: JSON.stringify(_.pick(_.find(actionType, {slug: 'penalty_declaration'}), ['@id', 'slug'])),
            settings: {
                penaltyResultSettings: _.pick(_.find(actionType, {slug: 'penalty_resultat'}), ['@id', 'slug'])
            },
            live
        }},
        {icon: cpa, text: 'Coup de pied arrêté', props: {
            history: props.history,
            to: `/live/${id}/coup-de-pied-arrete`,
            action: JSON.stringify(_.pick(_.find(actionType, {name: 'Coup de pied arrêté'}), ['data', '@id'])),
            settings: {
                tir: 'coup de pied arrêté'
            },
            live: live
        }}
    ]

    return(
        <Page
            renderFixed={() => {
                return (
                    <div className='ls_close_declare_action'>
                        <Fab 
                            modifier='ls_fab_close' 
                            position='bottom right'
                            onClick={() => props.history.goBack()}
                        >
                            <Icon icon='md-close' size={26} />
                        </Fab>
                    </div>
                )
            }}
            id='declare'
            modifier='ls_page_declare_action'
            style={{margin: '1000% 0 0 0', display: 'flex', width: '100%', height: '100%'}}
            onShow={() => {
                const element = document.getElementById('declare')
                element.classList.add('animated-page')
            }}
        >
            <Grid 
                hasLine={false} 
                data={highlights}
                onClick={o => handleClickHighlights(o.props)} 
            />
            <div className='ls_overtime'>
                <Grid hasLine={false} data={overtime} columnNum={2} />
            </div>
            <div className='ls_actions_btn'>
                <Grid 
                    data={actions} 
                    columnNum={2}
                    onClick={o => handleClickActions(o.props)}
                />
            </div>
        </Page>
    );
}

const handleClickHighlights = props => props.history.push(`${props.to}?action_type=${JSON.stringify(props.action)}&settings=${JSON.stringify(props.settings)}`);

const handleClickActions = props => {
    if(isLiveInProgress(props.live)){
        props.history.push(`${props.to}?action_type=${props.action}&actions=${JSON.stringify(props.live.actions)}&score=${JSON.stringify(props.live.score)}&settings=${JSON.stringify(props.settings)}`);
    }
}

const mapStateToProps = ({connexionReducer}) => ({connexionReducer});

export default withRouter(connect(mapStateToProps)(DeclareActionPage));